import React from "react";
import selfimg from '../img/chex_shirt_-removebg2.png';
export default function Home() {
  return (
    <div className="container-md " id="home">
      <div className="row align-items-center">
        <div className="col-lg-6 p-2">
          <span className="align-middle Inconsolata fs-6">
            Hello World! My name is
          </span>
          <br />
          <span
            className="fs-1 fw-bold"
            id="user-detail-name"
            style={{ width: "6rem" }}
          >
            PRATHMESH KURANE
          </span>
          <br />
          <span className="fs-4 IBM-Plex-Mono">Java Back-end Developer</span>
          <br />
          <br />

          <span className="fs-6 Space-Mono" >
            I'm an India based software developer with a goal-driven creative
            mindset and passion for learning and innovating.
          </span>
          <br />
          <br />
          <br />
         
        </div>
        <div className="col-lg-6 mx-auto">
          <div className="card " style={{border:"none"}}>
            <img
              src={selfimg}
              className="card-img-top myimg home-img"
              alt="My Photo"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
